// extracted by mini-css-extract-plugin
module.exports = {"header":"open-documents_header__BDQXJ","table":"open-documents_table__dnHrT","cell":"open-documents_cell__DCbkd","cellMetadata":"open-documents_cellMetadata__t8NYK"};